import { includedPhotoGalleryImagesNormalizedData } from '../../../Components/PhotoGallery/IncludedPhotoGalleryImagesNormalizedData';
import IncludedPhotoGalleryImageNormalizedData from '../../../Components/PhotoGallery/IncludedPhotoGalleryImageNormalizedData';
import FloorPlanNormalizedDataCore from '../FloorPlan/FloorPlanNormalizedDataCore';

const JSONAPIDeserializer = require( 'jsonapi-serializer' ).Deserializer;

const ResidenceNormalizedData = async ( responseData ) => {
  const options = {
    keyForAttribute: 'camelCase',
  };
  const deserializedData = await new JSONAPIDeserializer( options ).deserialize( responseData );
  const included = responseData?.included;

  // The marjority of residence fields are on the floor plan, so we start with that.
  const residenceCore = FloorPlanNormalizedDataCore( deserializedData, included );
  const residenceFpCore = FloorPlanNormalizedDataCore( deserializedData.fieldFloorPlan, included );

  const combinedCore = {}
  for (var prop in residenceCore ) {
    let valueToKeep = null;
    let resVal = residenceCore[prop];
    let fpVal = residenceFpCore[prop];
    switch(prop) {
      case 'photoGalleryImages':
        valueToKeep = [ ...resVal, ...fpVal ];
        break;
      case 'title' :
        // save floor plan title as different property;
        valueToKeep = resVal;
        combinedCore.floorPlanTitle = fpVal;
        break;
      default:
        // For most values we use the fp value unless the residence has one.
        valueToKeep = ( !resVal || resVal === '' || resVal.length === 0 || Object.keys(resVal).length === 0) ? fpVal : resVal;
        break;
    }

    combinedCore[prop] = valueToKeep;
  }

  // Add residence only field data.
  const {
    fieldBuildingGrouping,
    fieldLevel,
    fieldStatus,
    fieldResidents,
    fieldViewPhotos,
    fieldViewGallery,
    fieldViewVideoId,
    fieldViewService,
    fieldViewVideo,
  } = deserializedData;

  // Grab only the data we need related to residence.
  const residentArray = [];
  fieldResidents.forEach(function(resident) {
    let residentData = {
      firstName: resident.fieldFirstName,
      lastName: resident.fieldLastName,
      uuid: resident.id,
    }
    residentArray.push(residentData);
  });

  // Assemble view data.
  const view = [];

  // view - new video
  if ( fieldViewVideoId && fieldViewService ) {
    const viewItem = {
      type: 'Video',
      data: {
        service: fieldViewService,
        videoId: fieldViewVideoId,
      },
    };
    view.push( viewItem );
  }

  // view - existing video
  const viewExistingVideoId = fieldViewVideo?.fieldVideoId;
  const viewExistingVideoService = fieldViewVideo?.fieldVideoService;
  if ( viewExistingVideoId && viewExistingVideoService ) {
    const viewItem = {
      type: 'Video',
      data: {
        service: viewExistingVideoService,
        videoId: viewExistingVideoId,
      },
    };
    view.push( viewItem );
  }

  // View - unit view images, then unit gallery
  let viewPhotoGalleryImages = [];

  // View - Unique photos
  if ( fieldViewPhotos.length > 0 ) {
    fieldViewPhotos.forEach( ( deserializedImage, index) => {
      const serializedImage = responseData.data.relationships.field_view_photos.data[index];
      const image = IncludedPhotoGalleryImageNormalizedData(
        serializedImage,
        deserializedImage,
        included,
      );
      viewPhotoGalleryImages.push( image );
    } );
  }

  // View - Existing Gallery
  const viewGalleryId = fieldViewGallery?.id;
  if ( viewGalleryId ) {
    const includedIndex = included?.findIndex(
      ( include ) => include.id === fieldViewGallery?.id,
    );
    const viewGalleryImages = includedPhotoGalleryImagesNormalizedData(
      fieldViewGallery?.fieldGalleryPhotos,
      includedIndex,
      included,
    );
    viewPhotoGalleryImages = [ ...viewPhotoGalleryImages, ...viewGalleryImages ];
  }

  // Add all view images as gallery to view.
  if ( viewPhotoGalleryImages?.length > 0 ) {
    const viewItem = {
      type: 'PhotoGallery',
      data: viewPhotoGalleryImages,
    };
    view.push( viewItem );
  }

  const additionalData = {
    buildingGroupingName: fieldBuildingGrouping?.name,
    buildingGroupingUuid: fieldBuildingGrouping?.id,
    levelName: fieldLevel?.name,
    levelUuid: fieldLevel?.id,
    statusName: fieldStatus?.name,
    statusUuid: fieldStatus?.id,
    residents: residentArray,
    view,
  };

  const residence = { ...combinedCore, ...additionalData };

  return residence;
};

export default ResidenceNormalizedData;
